import { FlightResult, ItineraryFlightBooking } from '@/travelsuit'

export function getFlightEndTime(flight: FlightResult | ItineraryFlightBooking) {
	const lastSlice = flight.flights[flight.flights.length - 1]
	const lastSegment = lastSlice.segments[lastSlice.segments.length - 1]
	return lastSegment.arrival_time ?? lastSegment.arrival.datetime
}
